import { Link, NavLink } from "react-router-dom";
import { UserRound } from "lucide-react";
import { cn } from "../../lib/utils";
import logoImg from "../image/assets/mrjoe-logo-light.svg";

export default function Header() {
  const navLinkClass = ({ isActive }: { isActive: boolean }) => cn("hover:text-primary", isActive && "text-primary");

  return (
    <header className="bg-page-gray-soft border-mute w-full border-b">
      <div className="container-safe grid h-14 grid-cols-[auto_1fr_auto] items-center">
        <Link to="/">
          <img src={logoImg} alt="MrJoe.pro logo" className="h-10 w-auto" />
        </Link>
        <nav className="justify-self-center max-md:hidden">
          <ul className="flex items-center gap-2 font-normal md:gap-10 lg:gap-[70px] text-primary">
            <li><NavLink to="/pub/about_us" className={navLinkClass}>About</NavLink></li>
            <li><NavLink to="/pub/faq" className={navLinkClass}>FAQ</NavLink></li>
            <li><NavLink to="/pub/contact_us" className={navLinkClass}>Contact</NavLink></li>
            <li><NavLink to="/create_company" className={navLinkClass}>Try for free</NavLink></li>
            
          </ul>
        </nav>
        <div className="justify-self-end text-primary">
          <a href="/login" className="flex items-center gap-2 font-normal">
            <div className="bg-muted grid size-8 place-items-center rounded-full">
              <UserRound className="size-[18px]" />
            </div>
            <span className="max-xs:hidden">Login</span>
          </a>
        </div>
      </div>
    </header>
  );
}